import { motion } from "framer-motion";
import { SERVICES } from "@/data/site";
import { SectionTag } from "@/components/Kinetic";
import { EASE, viewport } from "@/lib/motion";

export const Services = () => (
  <section
    id="services"
    data-testid="services"
    className="relative border-t border-[#1f1f1f] py-20 md:py-32"
  >
    <div className="mx-auto max-w-[1700px] px-5 md:px-10">
      <SectionTag num="03 / SERVICES">WHAT I EDIT</SectionTag>

      <div className="mb-12 grid gap-8 lg:grid-cols-12">
        <h2 className="font-display text-4xl font-black uppercase leading-[0.88] tracking-[-0.04em] text-[#e5e5e5] lg:col-span-7 lg:text-[3.8vw]">
          EVERY SECOND
          <br />
          HAS A <span className="text-[#d4ff00]">JOB.</span>
        </h2>
        <p className="max-w-md self-end text-sm leading-relaxed text-[#a3a3a3] lg:col-span-5">
          Four things I get asked for most. Motion and graphic design run
          through all of them.
        </p>
      </div>

      <div className="grid gap-px bg-[#1f1f1f] md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.id}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={viewport}
            transition={{ duration: 0.8, ease: EASE, delay: (i % 2) * 0.08 }}
            data-testid={`service-${s.id}`}
            className="group relative bg-[#0a0a0a] p-7 transition-colors duration-500 hover:bg-[#111111] md:p-10 lg:p-12"
          >
            <div className="flex items-center justify-between">
              <span className="label text-[#d4ff00]">{s.tag}</span>
              <span className="font-mono text-xs text-[#4d4d4d]">
                0{i + 1}
              </span>
            </div>
            <h3 className="mt-7 font-display text-xl font-extrabold uppercase leading-tight tracking-[-0.02em] text-[#e5e5e5] md:text-2xl">
              {s.title}
            </h3>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-[#a3a3a3]">
              {s.body}
            </p>
            <div className="mt-7 flex flex-wrap gap-2">
              {s.items.map((it) => (
                <span
                  key={it}
                  className="border border-[#262626] px-3 py-2 label text-[#a3a3a3] transition-colors duration-300 group-hover:border-[#333]"
                >
                  {it}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
